/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { performanceMetricsList } from "../../funcs/performanceMetricsList.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$performanceMetricsList: ToolDefinition = {
  name: "performance-metrics-list",
  description: `List available performance metrics and related models

Returns the list of success data that can be requested to assess our forecasting models performance`,
  tool: async (client, ctx) => {
    const [result, apiCall] = await performanceMetricsList(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
